import { fetcher } from '../../../lib/api-fetcher';
import { useQuery } from '@tanstack/react-query';


export const healthKeys = {
  all: ['health'] as const,
  details: () => [...healthKeys.all, 'details'] as const,
};

export interface QueueJobCounts {
  name: string;
  waiting: number;
  active: number;
  completed: number;
  failed: number;
  delayed: number;
}

export interface HealthDetails {
  allOk: boolean;
  db: {
    status: 'ok' | 'error';
    latencyMs: number;
    poolTotal: number;
    poolActive: number;
    poolIdle: number;
    poolWaiting: number;
  };
  redis: {
    status: 'ok' | 'error';
    latencyMs: number;
    version: string;
    uptimeSeconds: number;
    usedMemoryBytes: number;
    peakMemoryBytes: number;
    totalConnections: number;
  };
  bullMq: QueueJobCounts[];
  api: {
    status: string;
    uptimeSeconds: number;
    version: string;
    nodeVersion: string;
    platform: string;
    arch: string;
    cpus: number;
    loadAvg: number[];
    processId: number;
    startTime: string;
    lastChecked: string;
  };
  system: {
    uptimeSeconds: number;
    apiVersion: string;
    nodeVersion: string;
    platform: string;
    arch: string;
    cpus: number;
    loadAvg: number[];
    processId: number;
    startTime: string;
    heapUsed: number;
    heapTotal: number;
    rss: number;
    lastChecked: string;
  };
  env: {
    nodeEnv: string;
    deploymentMode: string;
    storageDriver: string;
    modules: string[];
  };
  license: {
    valid: boolean;
    licensee?: string;
    modules?: string[];
    expiresAt?: string;
    error?: string;
  };
  storage: {
    driver: string;
    status: 'ok' | 'error';
    writable: boolean;
    path: string;
  };
  sentry: {
    configured: boolean;
  };
  externalServices: Record<string, { configured: boolean }>;
  git: {
    commitSha: string;
    branch: string;
  };
}

export function getHealthDetails(): Promise<HealthDetails> {
  return fetcher.get<HealthDetails>('/admin/health');
}

export function useHealthDetails() {
  return useQuery({
    queryKey: healthKeys.details(),
    queryFn: getHealthDetails,
    refetchInterval: 30_000,
  });
}
